import CurrencyList from './CurrencyList';

const currencies = {
	list: CurrencyList
};

export default currencies;
